import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material/material.module';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { ContextualNotificationComponent } from './components/contextual-notification/contextual-notification.component';
import { IdlePopupComponent } from '@shared/components/idle-popup/idle-popup.component';
import { NotificationComponent } from './components/notification/notification.component';
import { HeaderComponent } from '@shared/components/header/header.component';
import { FooterComponent } from '@shared/components/footer/footer.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { GlobalSearchComponent } from './components/global-search/global-search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  DxAutocompleteModule,
  DxDataGridModule,
  DxPopoverModule,
  DxScrollViewModule,
  DxPopupModule,
} from 'devextreme-angular';
import { GlobalSearchListComponent } from './components/global-search-list/global-search-list.component';
import { GahMatDialogComponent } from './components/gah-mat-dialog/gah-mat-dialog.component';
import { AssetCartCheckoutDownloadPopupComponent } from './components/asset-cart-checkout-download-popup/asset-cart-checkout-download-popup';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { GahMatPopupComponent } from './components/gah-mat-popup/gah-mat-popup.component';
import { DxCheckBoxModule } from 'devextreme-angular';

@NgModule({
  declarations: [
    ContextualNotificationComponent,
    NotificationComponent,
    IdlePopupComponent,
    HeaderComponent,
    FooterComponent,
    GlobalSearchComponent,
    GlobalSearchListComponent,
    GahMatDialogComponent,
    AssetCartCheckoutDownloadPopupComponent,
    GahMatPopupComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    NgScrollbarModule,
    ReactiveFormsModule,
    FormsModule,
    NgxSpinnerModule,
    DxPopoverModule,
    DxPopupModule,
    DxScrollViewModule,
    DxDataGridModule,
    RouterModule,
    TranslateModule,
    DxAutocompleteModule,
    NgxSkeletonLoaderModule,
    DxCheckBoxModule,
  ],
  exports: [
    ContextualNotificationComponent,
    NotificationComponent,
    IdlePopupComponent,
    HeaderComponent,
    FooterComponent,
    AssetCartCheckoutDownloadPopupComponent,
  ],
})
export class SharedModule {}
